import React, { useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Modal } from "react-bootstrap";
import UserDetailsDialogHeader from "./UserDetailsDialogHeader";
import UserDetailsDialogForm from "./UserDetailsDialogForm";
import * as actions from "../../../../redux/actions/users";

export default function UserDetailsDialog({ id, show, onHide }) {
  const dispatch = useDispatch();

  const {
    actionsLoading,
    userForDetails,
    userInformation,
    userInformationLoading,
  } = useSelector(
    (state) => ({
      actionsLoading: state.users2.actionsLoading,
      userForDetails: state.users2.userForDetails,
      userInformation: state.users2.userInformation,
      userInformationLoading: state.users2.userInformationLoading,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (id) {
      dispatch(actions.fetchUser(id));
      dispatch(actions.userInformation(id));
    }
  }, [id, dispatch]);

  return (
    <Modal
      size="lg"
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <UserDetailsDialogHeader
        id={id}
        registeredDate={userForDetails?.created_at}
      />
      <UserDetailsDialogForm
        actionsLoading={actionsLoading}
        userInformationLoading={userInformationLoading}
        user={userForDetails}
        userInformation={userInformation}
        onHide={onHide}
      />
    </Modal>
  );
}
